import { useContext, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import AuthContext from "../context/auth/AuthContext";
import { isAdminLoggedIn } from "../Utils/adminLogin";

const ProtectedRouteAdmin = ({ component }) => {
  const authContext = useContext(AuthContext);
  const { isLoggedIn } = authContext;
  const navigate = useNavigate();

  useEffect(() => {
    // Check if user is logged in as admin using the utility function
    const isAdmin = isAdminLoggedIn();

    if (!isAdmin && !isLoggedIn) {
      // If not logged in as admin, redirect to home
      // (The admin panel should handle the login flow)
      navigate("/home");
    }
  }, [isLoggedIn, navigate]);

  // Check admin status before rendering
  const isAdmin = isAdminLoggedIn();

  // Allow access if either admin is logged in via admin panel OR regular user is logged in
  if (!isAdmin && !isLoggedIn) {
    return null;
  }

  return component;
};

export default ProtectedRouteAdmin;
